module.exports = __webpack_public_path__ + "static/media/ic_template_8.3d731f2f.png";